import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

const ConfirmBooking = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const [cartItems, setCartItems] = useState([]);
  const [addons, setAddons] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loadData = () => {
      let cartData = JSON.parse(localStorage.getItem("cart")) || [];
      if (!Array.isArray(cartData)) cartData = [cartData];

      setCartItems(cartData);

      const addonsData = JSON.parse(localStorage.getItem("selectedAddons")) || [];
      setAddons(addonsData);

      setUser(JSON.parse(localStorage.getItem("user")));
    };

    loadData();

    window.addEventListener("focus", loadData); // ✅ important

    return () => {
      window.removeEventListener("focus", loadData);
    };
  }, []);

  useEffect(() => {
    const addonsData = JSON.parse(localStorage.getItem("selectedAddons")) || [];
    setAddons(addonsData);
  }, [location]);


  // ✅ EMPTY CHECK
  if (cartItems.length === 0) {
    return <h3 style={{ textAlign: "center" }}>No Booking Found</h3>;
  }

  // ✅ BASE TOTAL
  const baseTotal = cartItems.reduce(
    (sum, item) => sum + (item.price || 0),
    0
  );

  // ✅ ADDONS
  const addonTotal = addons.reduce((total, item) => {
    return total + item.price * item.quantity;
  }, 0);


  // ✅ TAX
  const tax = (baseTotal + addonTotal) * 0.18;

  // ✅ FINAL TOTAL
  const total = baseTotal + addonTotal + tax;

  // ✅ CONFIRM BOOKING (FIXED)
  const handleConfirmBooking = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));

    if (!userData) {
      Swal({
        icon: "warning",
        title: "Login Required",
        text: "Please login first to continue booking",
        buttons: ["Cancel", "Go to Login"],
      }).then((goLogin) => {
        if (goLogin) {
          navigate("/login");
        }
      });

      return;
    }

    try {
      const bookingPayload = {
        customerId: user?.id,
        totalAmount: baseTotal,
        taxAmount: tax,
        finalAmount: total,

        addonTotal: addonTotal,

        bookingDetails: cartItems.map(item => ({
          boatId: item.id,
          boatName: item.boatName,
          bookingDate: item.date,
          timeSlot: item.time,
          location: item.location,
          price: item.price
        })),

        // ✅ IMPORTANT
        addons: addons.map(item => ({
          name: item.name,
          type: item.type,
          quantity: item.quantity,
          price: item.price
        }))
      };


      // ✅ FIX: await added
      const res = await fetch(`${API_URL}booking/SaveBooking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bookingPayload),
      });

      const data = await res.json();

      if (data.success) {
        Swal({
          icon: "success",
          title: "Booking Confirmed!",
          text: "Your booking has been saved successfully",
          timer: 1500,
          buttons: false,
        });

        // ✅ Clear storage
        localStorage.removeItem("cart");
        localStorage.removeItem("selectedAddons");

        // ✅ Redirect with booking id
        setTimeout(() => {
          navigate(`/thankyou/${data.bookingId}`);
        }, 1500);
      } else {
        Swal("Error", "Booking failed", "error");
      }
    } catch (error) {
      console.error(error);
      Swal("Error", "Something went wrong", "error");
    }
  };

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="booking-summary-container">
        <div className="confirm_start">

          <button
            onClick={() => navigate("/addons")}
            className="th-btn style3 th-icon"
          >
            Back
          </button>
          <h2 className="summary-heading"> {"      "}Confirm Your Booking Details</h2>
        </div>

        <div className="summary-content-grid">

          {/* LEFT SIDE */}
          <div className="summary-details-column">

            {/* USER DETAILS */}
            <div className="summary-group">
              <h3 className="group-title">Customer Details</h3>

              <div className="detail-row">
                <span>Name:</span>
                <span>{user?.name || "Guest User"}</span>
              </div>

              <div className="detail-row">
                <span>Mobile:</span>
                <span>{user?.mobileNumber || "-"}</span>
              </div>

              <div className="detail-row">
                <span>Email:</span>
                <span>{user?.emailId || "-"}</span>
              </div>
            </div>

            {/* BOAT DETAILS */}
            <div className="summary-group summary-group-primary">
              <h3 className="group-title">Yacht & Slot Details</h3>

              {cartItems.map((item, index) => (
                <div key={index} style={{ marginBottom: 15 }}>

                  <div className="detail-row">
                    <span>Yacht:</span>
                    <span>{item.boatName}</span>
                  </div>

                  <div className="detail-row">
                    <span>Date & Time:</span>
                    <span>{item.date} ({item.time})</span>
                  </div>

                  <div className="detail-row">
                    <span>Location:</span>
                    <span>{item.location}</span>
                  </div>

                  <div className="detail-row">
                    <span>Price:</span>
                    <span>₹ {item.price}</span>
                  </div>

                  <hr />
                </div>
              ))}
            </div>
            <div className="summary-group summary-group-primary">
              <h3 className="group-title">Selected Add-Ons</h3>

              {addons && addons.length > 0 ? (
                addons.map((item, index) => (
                  <div key={index} style={{ marginBottom: 15 }}>

                    <div className="detail-row">
                      <span>Item:</span>
                      <span>{item.name}</span>
                    </div>

                    <div className="detail-row">
                      <span>Type:</span>
                      <span>{item.type}</span>
                    </div>

                    <div className="detail-row">
                      <span>Category:</span>
                      <span>{item.category}</span>
                    </div>

                    <div className="detail-row">
                      <span>Quantity:</span>
                      <span>{item.quantity}</span>
                    </div>

                    <div className="detail-row">
                      <span>Price:</span>
                      <span>₹ {item.price}</span>
                    </div>

                    <div className="detail-row">
                      <span>Total:</span>
                      <span>₹ {item.price * item.quantity}</span>
                    </div>

                    <hr />
                  </div>
                ))
              ) : (
                <div>No Addons Selected</div>
              )}
            </div>

            {/* ADDONS */}
            {/* <div className="summary-group">
              <h3 className="group-title">Selected Add-Ons</h3>

             {addons && addons.length > 0 ? (
  addons.map((item, index) => (
    <div key={index}>
      {item.name} ({item.type}) × {item.quantity} = ₹ {item.price * item.quantity}
    </div>
  ))
) : (
  <div>No Addons Selected</div>
)}

            </div> */}

          </div>

          {/* RIGHT SIDE */}
          <div className="summary-price-column">

            <div className="price-row">
              Base Total: ₹ {baseTotal}
            </div>

            <div className="price-row">
              Addons: ₹ {addonTotal}
            </div>

            <div className="price-row">
              Tax (18%): ₹ {tax.toFixed(2)}
            </div>

            <div className="price-row">
              <b>Total: ₹ {total.toFixed(2)}</b>
            </div>

            <button
              className="confirm-booking-btn"
              onClick={handleConfirmBooking}
            >
              Confirm Booking
            </button>
            <Sidebar />
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default ConfirmBooking;
